(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/components/result/result-province.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/components/result/result-province.js');

'use strict';

const grassrootsQueryApi = svs.grassroots.store.grassrootsQueryApi;
const ResultChart = svs.grassroots.components.result.ResultChart;
const ErrorDialog = svs.grassroots.components.ErrorDialog;
const Loader = svs.components.ReactLoader.Loader;
const _svs$ui = svs.ui,
  _svs$ui$ReactCard = _svs$ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardBody = _svs$ui$ReactCard.CardBody,
  CardGroup = _svs$ui$ReactCard.CardGroup,
  _svs$ui$ReactForm = _svs$ui.ReactForm,
  Select = _svs$ui$ReactForm.Select,
  Option = _svs$ui$ReactForm.Option;
const ResultProvince = _ref => {
  let cms = _ref.cms,
    provinces = _ref.provinces,
    currentProvince = _ref.currentProvince,
    setCurrentProvince = _ref.setCurrentProvince;
  const response = grassrootsQueryApi.useFetchResultProvinceQuery([cms.year, currentProvince.name]);
  const getChartDataProvince = () => ({
    categories: response.data.record.receivers.map(receiver => receiver.name),
    values: response.data.record.receivers.map(receiver => receiver.amount)
  });
  const getChartDataSports = () => ({
    categories: response.data.record.sports.map(sport => sport.name),
    values: response.data.record.sports.map(sport => sport.amount)
  });
  if (response.isError) {
    return React.createElement(ErrorDialog, null);
  }
  if (response.isLoading) {
    return React.createElement(Loader, {
      size: 300
    });
  }
  return React.createElement("div", {
    className: "margin-top-1"
  }, React.createElement(Select, {
    id: "valj-lan",
    label: cms.provinceResult.dropdownProvince,
    onChange: setCurrentProvince,
    v2: true,
    value: currentProvince.name
  }, provinces.map(province => React.createElement(Option, {
    key: province.id,
    name: province,
    value: province.name
  }, province.name))), response.isLoading && React.createElement(Loader, {
    size: 300
  }), response.isSuccess && response.data.record && React.createElement("div", {
    className: "margin-top-1"
  }, React.createElement(CardGroup, null, React.createElement(Card, {
    branding: svs.grassroots.tenant
  }, React.createElement(CardBody, null, React.createElement("h2", {
    className: "h3 align-center"
  }, cms.provinceResult.payoutHeading), React.createElement("h1", {
    className: "grassroots-result-total-amount-header align-center"
  }, response.data.record.amount.toLocaleString('sv-SE'), ' ', "kr"))), React.createElement(Card, {
    branding: svs.grassroots.tenant
  }, React.createElement(CardBody, null, React.createElement("h2", {
    className: "h3 align-center"
  }, cms.provinceResult.numberOfReceivers), React.createElement("h1", {
    className: "grassroots-result-total-amount-header align-center"
  }, response.data.record.organizationsCount.toLocaleString('sv-SE'), ' ', "st")))), React.createElement(Card, {
    branding: svs.grassroots.tenant
  }, React.createElement(CardBody, null, React.createElement(ResultChart, {
    data: getChartDataProvince(),
    title: cms.provinceResult.payoutByReceiverHeading
  }))), React.createElement(Card, {
    branding: svs.grassroots.tenant,
    className: "margin-top-1"
  }, React.createElement(CardBody, null, React.createElement(ResultChart, {
    data: getChartDataSports(),
    title: cms.provinceResult.payoutBySportHeading
  })))));
};
svs.grassroots.components.result.ResultProvince = ResultProvince;

 })(window);